import React from 'react';
import { useParams, useNavigate } from 'react-router';
import { AppShell } from '../components/layout';
import { Button } from '../components/ui';
import { TestCasesModal } from '../components/projects/Modals';

const TestCasePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    navigate('/auth/login');
  };

  return (
    <AppShell user={user} onLogout={handleLogout}>
      <div style={{ width: '100%', minHeight: '100%', background: 'var(--bg-primary)' }}>
        <Button variant="ghost" onClick={() => navigate(-1)} style={{ marginBottom: 12 }}>
          ← Back
        </Button>
        <TestCasesModal storyId={id} />
      </div>
    </AppShell>
  );
};

export default TestCasePage;
